import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import Cookies from 'js-cookie'

import { SENTRY_DSN } from '../config/index'
import { getClientEnv, getDesensitizedResult } from './utils'
import * as _package from '../../package.json'

const version = `xp-digital-service-insurance@${_package.version}`

const environment = getClientEnv()
const debug = environment === 'dev' || environment === 'test'

const SentryInit = (devNeed = false) => {
  if (!devNeed && environment === 'dev') {
    return
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment,
    release: version,
    debug,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
    beforeSend: event => {
      const wasxuid_r = Cookies.get('wasxuid_r')
      event.user = event.user || {}
      event.user.id = wasxuid_r
      debug && console.log('Sentry beforeSend: ', event)
      return event
    }
  })
}

export const SentryCaptureError = (message: string, options?: Record<string, string | number>) => {
  Sentry.withScope(scope => {
    const desensitizedOptions = getDesensitizedResult(options)
    desensitizedOptions && scope.setExtras(desensitizedOptions)
    Sentry.captureMessage(message, {
      tags: { errorType: 'captureException' },
      level: Sentry.Severity.Error
    })
  })
}

export const SentryCaptureExceptionParam = (param = 'channel', options?: Record<string, string | number>) => {
  Sentry.withScope(scope => {
    const desensitizedOptions = getDesensitizedResult(options)
    desensitizedOptions && scope.setExtras(desensitizedOptions)
    Sentry.captureMessage(`${param}参数丢失`, {
      tags: { errorType: 'captureException' },
      level: Sentry.Severity.Error
    })
  })
}

export const SentryCaptureExceptionBiz = (message: string, options?: Record<string, string | number>) => {
  Sentry.withScope(scope => {
    const desensitizedOptions = getDesensitizedResult(options)
    desensitizedOptions && scope.setExtras(desensitizedOptions)
    Sentry.captureMessage(message, {
      tags: { errorType: 'captureExceptionBiz' },
      level: Sentry.Severity.Info
    })
  })
}

export const SentryCaptureExceptionApi = (
  url: string,
  method = 'get',
  err: string,
  params?: any,
  data?: any
) => {
  Sentry.withScope(scope => {
    scope.clearBreadcrumbs()
    const desensitizedParams = getDesensitizedResult(params)
    const desensitizedData = getDesensitizedResult(data)
    scope.addBreadcrumb({
      type: 'a network request excepted',
      level: Sentry.Severity.Info,
      data: { url, method, params: desensitizedParams, data: desensitizedData }
    })
    const title = `${err}${url ? `: ${url}` : ''}`
    scope.setExtra('apiUrl', url)
    scope.setExtra('method', method)
    scope.setExtra('err', err)
    Sentry.captureMessage(title, {
      tags: { errorType: 'captureExceptionApi' },
      level: Sentry.Severity.Error
    })
  })
}

export const SentryCaptureFailureApi = (
  url: string,
  method = 'get',
  err: string,
  params?: any,
  data?: any
) => {
  Sentry.withScope(scope => {
    scope.clearBreadcrumbs()
    const desensitizedParams = getDesensitizedResult(params)
    const desensitizedData = getDesensitizedResult(data)
    scope.addBreadcrumb({
      type: 'a network request failed',
      level: Sentry.Severity.Info,
      data: { url, method, params: desensitizedParams, data: desensitizedData }
    })
    const title = `${err}${url ? `: ${url}` : ''}`
    scope.setExtra('apiUrl', url)
    scope.setExtra('method', method)
    scope.setExtra('err', err)
    Sentry.captureMessage(title, {
      tags: { errorType: 'captureFailureApi' },
      level: Sentry.Severity.Warning
    })
  })
}

export default SentryInit
